import { useTranslation } from 'react-i18next'
import { useRecentPatients } from '@/hooks/api'

export function useRecentPatientsWidget() {
  const { t } = useTranslation('dashboard')
  const { data, isLoading } = useRecentPatients()

  const patients = data?.patients ?? []
  const isEmpty = !isLoading && patients.length === 0

  return { t, patients, isLoading, isEmpty }
}
